// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/css';

export default () => {
  const heroSliderElements = document.querySelectorAll('[component="hero-slider"]');

  heroSliderElements.forEach((heroSlider) => {
    const swiperElement = heroSlider.querySelector('.swiper.hero-slider');

    const swiper = new Swiper(swiperElement, {
      loop: true,
      slidesPerView: 1,
    });
  });
};
